import { render, staticRenderFns } from "./Detail-Purchase-Order.vue?vue&type=template&id=6d351092"
import script from "./Detail-Purchase-Order.vue?vue&type=script&lang=js"
export * from "./Detail-Purchase-Order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports